import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {FabTableState, filterStateChange, process} from "@fabric/components/table-filter/data-query";
import {map, Observable, ObservableInput, startWith, tap} from "rxjs";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {NotificationService} from "../../services/notification.service";
import {SecurityService} from "../../services/security.service";
import {FormControl, FormGroup, FormGroupDirective, Validators} from "@angular/forms";
import {PtoEmision} from "../../models/PtoEmision";
import {PtoEmisionService} from "../../services/ptoEmision.service";
import {Clase, IdDescModel, RemitoCreationDetails, Solicitante} from '../../models/RemitoCreationDetails';
import {RemitoService} from "../../services/remito.service";
import {Remito} from "../../models/Remito";
import {ReportRemito} from "../../models/ReportRemito";
import {IssuedRemitosReportService} from "../../services/issued-remitos-report.service";
import {Origen} from "../../models/Origen";
import {Almacen} from "../../models/Almacen";
import {AlmacenService} from "../../services/almacen.service";
import {FabDateFilterOperator} from '../../shared-components/table-filter/date-filter/date-filter.component';
import {FabStringFilterOperator} from '../../shared-components/table-filter/string-filter/string-filter.component';

@Component({
  selector: 'app-report-remito',
  templateUrl: './issued-remitos-report.component.html',
  styleUrls: ['./issued-remitos-report.component.scss']
})
export class IssuedRemitosReportComponent implements OnInit {

  @ViewChild('formDirective') private formDirective: FormGroupDirective;

  displayedColumns: string[] = ['origen', 'nroRemito', 'nombreDealer', 'descAlmacen', 'nroShipper',
    'fecGen', 'shipTo', 'shipFrom', 'nombreTransp',  'estadoRemito'];

  dataSource: MatTableDataSource<ReportRemito> = new MatTableDataSource<ReportRemito>();
  dataSourceForm: MatTableDataSource<RemitoCreationDetails> = new MatTableDataSource<RemitoCreationDetails>();
  createDetailsData: RemitoCreationDetails[] = [];
  allIssuedRemitosReport: ReportRemito[] = [];
  operators: FabStringFilterOperator[] = ['contains'];
  public dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  errors: HttpErrorResponse[] = [];

  clase: Clase[] = [
    {id: 'N', viewValue: 'No Commercial'},
    {id: 'C', viewValue: 'Commercial'},
  ];

  origen: Origen[] = [];
  solicitante: Solicitante[] = [];
  destinatario: IdDescModel[] = [];
  almacen: Almacen[] = [];


  origenControl = new FormControl('');
  ptoEmisionControl = new FormControl('', Validators.required);

  // @ts-ignore
  nroRemitoStartValControl = new FormControl<number>(null, Validators.pattern("^[0-9]*$"));
  // @ts-ignore
  nroRemitoEndValControl = new FormControl<number>(null, Validators.pattern("^[0-9]*$"));
  destinatarioControl = new FormControl<string | IdDescModel>('');
  almacenControl = new FormControl<string | Almacen>('');
  // @ts-ignore
  nroShipperControl = new FormControl<number>(null, Validators.pattern("^[0-9]*$"));
  fechaDesdeControl = new FormControl<Date | null>(null);
  fechaHastaControl = new FormControl<Date | null>(null, {updateOn: "change"});
  remitoNumFromRoute: number;
  originSelected: boolean = false;
  ptoSelected: boolean = false;
  almacenSelected: boolean = false;
  searchCriteriaSelected: boolean = false;
  validationErrorMessage: string = '';
  isLoading: boolean = false;

  reportRemitoForm: FormGroup = new FormGroup({
    origen: this.origenControl,
    ptoEmision: this.ptoEmisionControl,
    destinatario: this.destinatarioControl,
    fechaDesde: this.fechaDesdeControl,
    fechaHasta: this.fechaHastaControl,
    almacen: this.almacenControl

  });

  allPtoEmision: PtoEmision[] = [];
  allDestinatario: IdDescModel[] = [];
  nroRemitoControl = new FormControl<string | null>({value: null, disabled: true});
  filteredDestinatario: Observable<IdDescModel[]> | undefined;
  filteredAlmacen: Observable<Almacen[]> | undefined;
  remitos: Remito;


  @ViewChild(MatPaginator) private paginator: MatPaginator;
  showReportData: boolean = false;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(private notificationService: NotificationService,
              private securityService: SecurityService,
              private remitoService: RemitoService,
              private ptoEmisionService: PtoEmisionService,
              private almacenService: AlmacenService,
              private reportRemitoService: IssuedRemitosReportService) {
  }

  ngOnInit(): void {

    this.getOrigins();
    this.getPtoEmisions();
    this.getDestinatarios();
    this.getAlamcens();
  }

  getOrigins() {

    this.reportRemitoService.getOrigins().subscribe((response) => {

      this.origen = response;
      this.origenControl.setValue("-1");
      for (let i = 0; i < this.origen.length; i++) {
        let val: any;
        val = this.origen[i];
        this.origenControl.setValue(val);
      }
    });
  }

  getPtoEmisions() {
    this.ptoEmisionService.getPartsPtoEmision().subscribe((response) => {
      this.allPtoEmision = response;

      for (let i = 0; i < this.allPtoEmision.length; i++) {
        {
          this.ptoEmisionControl.setValue(this.allPtoEmision[i].code)
        }
      }
    });
  }

  getDestinatarios() {

    this.remitoService.getDetails().subscribe((response) => {
      for (let i = 0; i < response.destinatario.length; i++) {
        this.destinatario.push(response.destinatario[i]);
      }
      this.populateDestinatario();
    });

  }

  populateDestinatario() {
    this.filteredDestinatario = this.destinatarioControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const destinatarioValue = typeof value === 'string' ? value : value?.desc;
        return destinatarioValue ? this.destinatarioFiltering(destinatarioValue as string) : this.destinatario.slice();
      }),
    );
  }

  private destinatarioFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.destinatario.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }




  getAlamcens() {

    this.almacenService.getAll().subscribe((response) => {
      for (let i = 0; i < response.length; i++) {
        {
          this.almacen.push(response[i])
        }
        this.populateAlmacen();
      }
    });
  }


  populateAlmacen() {
    this.filteredAlmacen = this.almacenControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const almacenVal = typeof value === 'string' ? value : value?.descAlmacen;
        return almacenVal ? this.almacenFiltering(almacenVal as string) : this.almacen.slice();
      })
    );
  }

  private almacenFiltering(name: string): Almacen[] {
    const filterValue = name.toLowerCase();
    return this.almacen.filter(option => option.descAlmacen.toLowerCase().includes(filterValue) || option.codAlmacen.toLowerCase().includes(filterValue));
  }


  onChangeOrigen(origen: any) {
    this.originSelected = true;
    this.origenControl.setValue(origen.value);
  }

  onChangePtoEmision(ptoEmision: any) {
    this.ptoSelected = true;
    this.ptoEmisionControl.setValue(ptoEmision.value);
  }

  onChangeDestinatario(destinatario: any) {
    this.destinatarioControl.setValue(destinatario.value);
  }

  onChangeAlmacen(almacen: any) {
    this.almacenSelected = true;
    this.almacenControl.setValue(almacen.value);
  }


  searchAndPrint(print : boolean) {
    if(print){
      this.isLoading = true;
    }
    this.getSearchData();
    this.validateSearchData();

    if (this.validationErrorMessage != '') {
      this.notificationService.open(this.validationErrorMessage, 'error');
      this.isLoading = false;
    } else {
      this.setAllOrigins();
      this.reportRemitoService.generateReport(this.remitos).subscribe((response) => {
        this.allIssuedRemitosReport = response;
        this.displayData(print);
      });

    }
  }

  displayData(print : boolean) {

    if (this.allIssuedRemitosReport.length == 1 && (this.allIssuedRemitosReport[0].totCont != null && this.allIssuedRemitosReport[0].totCont < 0)) {
      if(this.allIssuedRemitosReport[0].totCont == -1){
        //No results found related to your search, Please try different criteria.
        this.notificationService.open('No se encuentran resultados para la búsqueda. Por favor seleccione criterios diferentes.', 'warn');
      }else{
        //Your search resulted in too many items.\nPlease refine your search.
        this.notificationService.open('La búsqueda resultó en demasiados elementos.\nPor favor disminuya los criterios y vuelva a internar.', 'warn');
      }
      this.hideTable();
    } else {
      //this.dataSource = new MatTableDataSource<ReportRemito>(response);
      this.dataSource.data = process(this.allIssuedRemitosReport as any[], this.state);
      this.showReportData = true;
      this.setPagination();

      if(print){
        this.print();
      }
    }
  }

  hideTable() {
    this.showReportData = false;
    this.dataSource.data = [];
  }

  setAllOrigins() {
    if (this.remitos.origen == '-1') {
      this.remitos.origen = 'FRE,RO,WE,BAL';
    }
  }

  setPagination() {
    this.dataSource.paginator = this.paginator;
  }

  getSearchData() {

    this.remitos = new Remito();

    this.getOriginSearchCriteria();
    this.getNroRemitoNumberSearchCriteria();
    this.getPtoEmisionSearchCriteria();
    this.getDestinatarioSearchCriteria();
    this.getAlmacenSearchCriteria();
    this.getNroShipperNumberSearchCriteria();
    this.getFecGenSearchCriteria();
  }

  getOriginSearchCriteria() {



    if (this.originSelected) {
      // @ts-ignore
      this.remitos.origen = this.origenControl.value;
      if (this.remitos.origen == 'FREE') {
        this.remitos.origen = 'FRE';
      } else if (this.remitos.origen == 'MGO') {
        this.remitos.origen = 'RO,WE';
      } else if (this.remitos.origen == 'BALANZA') {
        this.remitos.origen = 'BAL';
      } else{
        this.remitos.origen = '-1';
      }
    } else {
      this.remitos.origen = '-1';
    }

  }

  getNroRemitoNumberSearchCriteria() {

    //nroEnd
    // @ts-ignore
    if (this.nroRemitoEndValControl.value == null || this.nroRemitoEndValControl.value == '' || !this.nroRemitoEndValControl.valid) {
      this.remitos.nroRemitoEnd = -1;
    } else {
      this.remitos.nroRemitoEnd = this.nroRemitoEndValControl.value;
    }

    //nroStart
    // @ts-ignore
    if (this.nroRemitoStartValControl.value == null || this.nroRemitoStartValControl.value == '' || !this.nroRemitoStartValControl.valid) {
      this.remitos.nroRemito = -1;
    } else {
      this.remitos.nroRemito = this.nroRemitoStartValControl.value;
      // @ts-ignore
      if (this.nroRemitoEndValControl.value == null || this.nroRemitoEndValControl.value == '' || !this.nroRemitoEndValControl.valid) {
        this.remitos.nroRemitoEnd = this.nroRemitoStartValControl.value;
      } else {
        this.remitos.nroRemitoEnd = this.nroRemitoEndValControl.value;
      }
    }
  }

  getPtoEmisionSearchCriteria() {

    if (this.ptoSelected) {
      this.remitos.ptoEmision = this.ptoEmisionControl.value;
    } else {
      this.remitos.ptoEmision = '-1';
    }
  }

  getDestinatarioSearchCriteria() {

    if (this.destinatarioControl.value != '' && this.destinatarioControl.value != '-1') {
      // @ts-ignore
      var [cod_dealer, ...nombre_dealer] = this.destinatarioControl.value.split('-');
      this.remitos.codDealer = cod_dealer;
      this.remitos.nombreDealer = nombre_dealer.join('-');
    } else {
      this.remitos.codDealer = "-1";
      this.remitos.nombreDealer = "-1";
    }
  }

  getAlmacenSearchCriteria() {

    if (this.almacenControl.value != '' && this.almacenControl.value != '-1') {
      // @ts-ignore
      var [cod_almacen, ...desc_almacen] = this.almacenControl.value.split('-');
      this.remitos.codAlmacen = cod_almacen;
      this.remitos.descAlmacen = desc_almacen.join('-');
    } else {
      this.remitos.codAlmacen = "-1";
      this.remitos.descAlmacen = "-1";
    }
  }

  getNroShipperNumberSearchCriteria() {

    // @ts-ignore
    if (this.nroShipperControl.value == null || this.nroShipperControl.value == '' || !this.nroShipperControl.valid) {
      this.remitos.nroShipper = -1;
    } else {
      this.remitos.nroShipper = this.nroShipperControl.value;
    }
  }

  getFecGenSearchCriteria() {

    //fec_desde
    if (this.fechaDesdeControl.value == null) {
      this.remitos.fecGenStart = "-1";
    } else {
      this.remitos.fecDesde = this.fechaDesdeControl.value;
      // @ts-ignore
      this.remitos.fecGenStart = this.fechaDesdeControl.value.toISOString().slice(0, 10);
    }

    //fec_hasta
    if (this.fechaHastaControl.value == null) {
      if (this.remitos.fecGenStart != "-1") {
        // @ts-ignore
        this.remitos.fecGenEnd = new Date(this.remitos.fecDesde.getTime() + (1000 * 60 * 60 * 24)).toISOString().slice(0, 10);
      } else {
        this.remitos.fecGenEnd = "-1";
      }
    } else {
      this.remitos.fecHasta = this.fechaHastaControl.value;
      // @ts-ignore
      this.remitos.fecGenEnd = new Date(this.remitos.fecHasta.getTime() + (1000 * 60 * 60 * 24)).toISOString().slice(0, 10);
    }
  }


  validateSearchData() {

    this.validationErrorMessage = '';

    if (this.remitos.origen != '-1' || this.remitos.ptoEmision != '-1' || this.remitos.nroRemito != -1
      || this.remitos.nroRemitoEnd != -1 || this.remitos.codDealer != '-1' || this.remitos.nroShipper != -1
      || this.remitos.codAlmacen != '-1' || this.remitos.fecDesde != null || this.remitos.fecHasta != null) {

      this.validateNroRemitoNumber();
      this.validateDates();

    } else {
      //Please enter at least ONE search criteria to continue!
      this.validationErrorMessage = 'Ingrese al menos UN criterio de búsqueda para continuar!';
      this.hideTable();
    }
  }

  validateNroRemitoNumber() {

    // @ts-ignore
    if (this.remitos.nroRemitoEnd != -1 && this.remitos.nroRemito == -1) {
      //Nro remito start value is required!
      this.validationErrorMessage = 'Se requiere el valor de inicio del nro remito!\n';
    } else if (this.remitos.nroRemitoEnd != null && this.remitos.nroRemito > this.remitos.nroRemitoEnd) {
      //Nro remito start value must be less than or equal to Nro remito end value!
      this.validationErrorMessage = 'El valor inicial del envío de Nro debe ser menor o igual que el valor final del envío de Nro!\n';
    }
  }

  validateDates() {

    if (this.remitos.fecHasta != null && this.remitos.fecDesde == null) {
      //Enter date_from!
      this.validationErrorMessage = this.validationErrorMessage + 'Ingresar fec_desde!';
    } else if (this.remitos.fecDesde != null && this.remitos.fecHasta != null) {
      // @ts-ignore
      if (this.remitos.fecDesde.getTime() > this.remitos.fecHasta.getTime()) {
        //fec_desde must be less than fec_hasta!
        this.validationErrorMessage = this.validationErrorMessage + 'fec_desde debe ser menor o igual que fec_hasta!';
      } else {
        // @ts-ignore
        let days = this.calculateDiff(this.remitos.fecDesde, this.remitos.fecHasta);
        if (days > 365) {
          //Please limit your search to a year.
          this.validationErrorMessage = this.validationErrorMessage + 'Por favor limite la búsqueda hasta a un año ';
        }
      }
    }
  }

  calculateDiff(startDate: any, endDate: any) {

    let days = Math.floor((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
    return days;
  }


  public filterChange(event: any) {
    this.state.skip = 0;
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.filterData();
  }

  private filterData() {
    this.dataSource.data = process(this.allIssuedRemitosReport, this.state)
  }

  print() { // Call printRemito like remito service
    this.reportRemitoService.downloadPdf(this.remitos).subscribe({
      next: (response) => {
        const newBlob = new Blob([response], {type: 'application/pdf'});
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        // @ts-ignore
        link.download = `Listado de Remitos Emitidos por Fecha.pdf`;
        link.click();
        this.isLoading = false;
      },
      error: (error) => {
        this.errors.push(error);
        this.notificationService.open(this.notificationService.getErrorByCode(error.errorCode),'error');
        this.isLoading = false;
      }
    })
  }

}
